'use strict';

import moment from 'moment-timezone';

moment.updateLocale('pt-br', {
  months: [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
  ],
  monthsShort: [
    'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
    'jul', 'ago', 'set', 'out', 'nov', 'dez'
  ],
  weekdays: [
    'domingo', 'segunda-feira', 'terça-feira', 'quarta-feira',
    'quinta-feira', 'sexta-feira', 'sábado'
  ],
  weekdaysShort: [
    'dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'
  ],
  weekdaysMin: ['do', 'se', 'te', 'qa', 'qi', 'sx', 'sa']
})

moment.locale('pt-br')
import momentBusinessDays from '../plugins/moment/moment-business-days';
const TIMEZONE = 'America/Sao_Paulo';

momentBusinessDays.updateLocale('us', {
  /* Feriados específicos, em casos onde apenas um dia específico de um ano específico é feriado */
  holidays: [],
  /* Formato em que os feriados estão */
  holidayFormat: 'DD/MM/YYYY',
  /* Força um dia como dia útil */
  forcedBusinessDays: [],
  /* Formato em que os dias forçados como útil estão */
  forcedBusinessDaysFormat: 'DD/MM/YYYY',
  /* Dias da semana que serão considerado como úteis. No padrão js, Domingo = 0 até Sábado = 7 */
  workingWeekdays: [1, 2, 3, 4, 5],
  /* Callback para filtrar os feriados. Seria o ponto para usar os feriados recorrentes */
  holiday: function (someMoment) {
    /* Meses no padrão js, Janeiro = 0 até Dezembro = 11 Exemplo de filtro:
    return someMoment.month() === 6 && someMoment.date() === 4; */
    return false;
  }
});

function maskDateIso(date, valueDateEmpty) {
  if (date) {
    return moment.tz(date, TIMEZONE).format('DD/MM/YYYY');
  }

  return valueDateEmpty ? valueDateEmpty : null;
}

function maskDateAndHourIso(date, valueDateEmpty) {
  if (date) {
    return moment.tz(date, TIMEZONE).format('DD/MM/YYYY HH:mm:ss');
  }

  return valueDateEmpty ? valueDateEmpty : null;
}

function maskDateAndHourWithoutSeconds(date, valueDateEmpty) {
  if (date) {
    return moment.tz(date, TIMEZONE).format('DD/MM/YYYY HH:mm');
  }

  return valueDateEmpty ? valueDateEmpty : null;
}

function formatDateAndHourIso(date, hour) {
  return `${moment.tz(date, TIMEZONE).format('YYYY-MM-DD')}T${hour || '00:00:00'}`;
}

function newDateAmericaTimeZone() {
  return moment.tz(TIMEZONE).format('YYYY-MM-DDTHH:mm:ss.SSS');
}
/* A data cai no dia de hoje pelo horário de Brasília */
function isTodayInBrazil(date) {
  if (!date) return false;

  return moment(date).tz(TIMEZONE).format('YYYY-MM-DD') === moment.tz(TIMEZONE).format('YYYY-MM-DD');
}

/* Data sem hora (YYYY-MM-DD) anterior ao dia de hoje pelo horário de Brasília */
function isBeforeTodayInBrazil(dateOnly) {
  if (!dateOnly) return false;

  return String(dateOnly).slice(0, 10) < moment.tz(TIMEZONE).format('YYYY-MM-DD');
}

function dateCompleteWithHour(date) {
  return moment(date).tz(TIMEZONE).locale('pt-br').format('dddd, D [de] MMMM [de] YYYY [às] HH:mm')
}

function endDateBiggerOrEqualStartDate(startDate, endDate) {
  return (
    !startDate ||
    startDate == '' ||
    !endDate ||
    endDate == '' ||
    new Date(startDate) <= new Date(endDate)
  );
}

function maskHourWithoutSeconds(date, valueDateEmpty) {
  if (date) {
    return moment.tz(date, TIMEZONE).format('HH:mm');
  }

  return valueDateEmpty ? valueDateEmpty : null;
}

function isBusinessDay(date) {
  return momentBusinessDays(moment.utc(date)).isBusinessDay();
}

function addBusinessDay(date, amount) {
  amount = amount || 0;
  return momentBusinessDays(moment.utc(date)).businessAdd(amount)._d;
}

function firstDayOfLastMonth() {
  return moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
}

function lastDayOfLastMonth() {
  return moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
}

function isValidDdMmYyyy(day, month, year, opts = {}) {
  const numericDay = parseInt(day, 10);
  const numericMonth = parseInt(month, 10);
  const numericYear = parseInt(year, 10);

  if (Number.isNaN(numericDay) || Number.isNaN(numericMonth) || Number.isNaN(numericYear))
    return false;

  const now = moment.tz(TIMEZONE);
  const minYear = typeof opts.minYear === 'number' ? opts.minYear : 1900;
  const maxYear = typeof opts.maxYear === 'number' ? opts.maxYear : now.year();
  const allowFuture = !!opts.allowFuture;

  if (numericYear < minYear || numericYear > maxYear) return false;
  if (numericMonth < 1 || numericMonth > 12) return false;
  if (numericDay < 1 || numericDay > 31) return false;

  const dateStr = `${String(numericDay).padStart(2, '0')}/${String(numericMonth).padStart(
    2,
    '0'
  )}/${numericYear}`;
  const parsed = moment(dateStr, 'DD/MM/YYYY', true);
  if (!parsed.isValid()) return false;

  if (!allowFuture) {
    const asIso = parsed.tz(TIMEZONE).format('YYYY-MM-DD');
    if (moment.tz(asIso, TIMEZONE).isAfter(now, 'day')) return false;
  }

  return true;
}

function toIsoFromDdMmYyyy(day, month, year, opts = {}) {
  if (!isValidDdMmYyyy(day, month, year, opts)) return null;

  const paddedDay = String(day).padStart(2, '0');
  const paddedMonth = String(month).padStart(2, '0');
  const yearString = String(year);

  return `${yearString}-${paddedMonth}-${paddedDay}`;
}

function parseDdMmYyyyToIso(dateStringDdMmYyyy, opts = {}) {
  if (
    !dateStringDdMmYyyy ||
    typeof dateStringDdMmYyyy !== 'string' ||
    dateStringDdMmYyyy.length !== 10
  )
    return null;
  const [day, month, year] = dateStringDdMmYyyy.split('/');
  return toIsoFromDdMmYyyy(day, month, year, opts);
}

function normalizeIsoDateOnly(source) {
  if (!source) return null;

  if (typeof source === 'string') {
    const m = source.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;

    const dt = moment(source);
    if (dt.isValid()) return dt.tz(TIMEZONE).format('YYYY-MM-DD');
    return null;
  }

  if (source instanceof Date && !isNaN(source.getTime())) {
    return moment(source).tz(TIMEZONE).format('YYYY-MM-DD');
  }

  return null;
}
function maskDdMmYyyyProgressive(input) {
  const raw = String(input || '')
    .replace(/[^0-9]/g, '')
    .slice(0, 8);

  if (raw.length <= 2) return raw;
  if (raw.length <= 4) return `${raw.slice(0, 2)}/${raw.slice(2)}`;

  return `${raw.slice(0, 2)}/${raw.slice(2, 4)}/${raw.slice(4)}`.slice(0, 10);
}

function isStringIsoDate(text) {
  return (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(text));
}

function formatDateOnlyToDisplay(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return '—';

  const [year, month, day] = dateStr.split('-');

  return `${day}/${month}/${year}`;
}

function addDaysToDateOnly(dateStr, days) {
  if (!dateStr || typeof dateStr !== 'string') return null;

  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d + days);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export default {
  maskDateIso,
  maskDateAndHourIso,
  maskDateAndHourWithoutSeconds,
  formatDateAndHourIso,
  isValidDdMmYyyy,
  toIsoFromDdMmYyyy,
  parseDdMmYyyyToIso,
  normalizeIsoDateOnly,
  maskDdMmYyyyProgressive,
  endDateBiggerOrEqualStartDate,
  maskHourWithoutSeconds,
  isBusinessDay,
  addBusinessDay,
  newDateAmericaTimeZone,
  isTodayInBrazil,
  isBeforeTodayInBrazil,
  firstDayOfLastMonth,
  lastDayOfLastMonth,
  dateCompleteWithHour,
  isStringIsoDate,
  formatDateOnlyToDisplay,
  addDaysToDateOnly
};
